import { Box, Typography } from '@mui/material';
import AdminLayout from '../../components/admin/AdminLayout';

const AdminOverviewPage = () => {
  return (
    <AdminLayout>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" color="text.primary" gutterBottom>
          Admin Overview
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Admin overview content will be implemented here.
        </Typography>
      </Box>
    </AdminLayout>
  );
};

export default AdminOverviewPage; 